/* Estimated arrival: "Order today, arrives Thu 15 Oct – Tue 20 Oct".
 *
 * Worked out in the browser so a cached page never shows yesterday's dates. Every
 * [data-runit-arrival] element is painted (and unhidden) here; without JavaScript it stays
 * hidden and the dispatch line beside it is the promise.
 *
 *   PDP  snippets/runit-purchase-details.liquid: no data-min/max, so the window is read off the
 *        visible dispatch line ("Dispatched in 2 weeks" or "Dispatched in 1 - 3 working days"). Variant, set and
 *        personalisation changes rewrite that line (assets/runit-tweaks.js), and this follows.
 *   Bag  snippets/runit-cart-order-summary.liquid: data-min/max from runit-cart-fulfilment
 *        (range: true), re-rendered with the bag.
 *   data-intl="true" outside the UK (Shopify localization).
 *
 * Day 0 is today on a working day before the 4pm cut-off (snippets/runit-dispatch-when.liquid),
 * else the next working day. Dispatch takes min–max working days from day 0, then delivery
 * takes UK Standard 2–3 / International Tracked 7–11 working days (templates/product.json,
 * "Delivery after dispatch"). Working days skip weekends and England & Wales bank holidays.
 */
(function () {
  // gov.uk England & Wales bank holidays.
  // ponytail: hard-coded to the end of 2028; after that only weekends are skipped. Add the next years here.
  var HOLIDAYS = ('2026-01-01 2026-04-03 2026-04-06 2026-05-04 2026-05-25 2026-08-31 2026-12-25 2026-12-28 ' +
    '2027-01-01 2027-03-26 2027-03-29 2027-05-03 2027-05-31 2027-08-30 2027-12-27 2027-12-28 ' +
    '2028-01-03 2028-04-14 2028-04-17 2028-05-01 2028-05-29 2028-08-28 2028-12-25 2028-12-26').split(' ');
  var CUTOFF_HOUR = 16;
  var DELIVERY = { uk: [2, 3], intl: [7, 11] };
  var DAY = 864e5;
  var WEEKDAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // London calendar date (as a UTC-midnight timestamp, immune to the clock change) and hour.
  function london(now) {
    var p = {};
    new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' })
      .formatToParts(new Date(now)).forEach(function (x) { p[x.type] = x.value; });
    return { day: Date.UTC(+p.year, +p.month - 1, +p.day), hour: +p.hour };
  }

  function isWorking(t) {
    var d = new Date(t);
    var w = d.getUTCDay();
    return w !== 0 && w !== 6 && HOLIDAYS.indexOf(d.toISOString().slice(0, 10)) < 0;
  }

  function addWorking(t, n) {
    while (n > 0) { t += DAY; if (isWorking(t)) n -= 1; }
    return t;
  }

  // [earliest, latest] arrival as UTC-midnight timestamps.
  function arrival(min, max, intl, now) {
    var l = london(now == null ? Date.now() : now);
    var start = isWorking(l.day) && l.hour < CUTOFF_HOUR ? l.day : addWorking(l.day, 1);
    var del = intl ? DELIVERY.intl : DELIVERY.uk;
    return [addWorking(start, min + del[0]), addWorking(start, max + del[1])];
  }

  function label(t) {
    var d = new Date(t);
    return WEEKDAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
  }

  function line(min, max, intl, now) {
    var a = arrival(min, max, intl, now);
    return 'Order today, arrives ' + label(a[0]) + ' – ' + label(a[1]);
  }

  window.rlArrival = { arrival: arrival, line: line };
  if (typeof document === 'undefined') return;

  var RANGE = /(\d+)\s*(?:-|–|to)\s*(\d+)\s*working days/i;
  var WEEKS = /(\d+)\s*weeks?/i;

  function paint() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-runit-arrival]'), function (el) {
      var min = el.getAttribute('data-min');
      var max = el.getAttribute('data-max');
      if (min === null) {
        var src = el.parentNode.querySelector('[data-runit-fulfilment-dispatch]');
        var m = src && !src.hidden && RANGE.exec(src.textContent);
        var w = src && !src.hidden && WEEKS.exec(src.textContent);
        min = m ? m[1] : w ? w[1] * 5 : '';
        max = m ? m[2] : w ? w[1] * 5 : '';
      }
      var text = min !== '' && max !== '' ? line(+min, +max, el.getAttribute('data-intl') === 'true') : '';
      var target = el.querySelector('[data-runit-arrival-text]') || el;
      if (target.textContent !== text) target.textContent = text;
      if (el.hidden !== !text) el.hidden = !text;
    });
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; paint(); }, 0); // not rAF: it never fires in a background tab
  }

  function start() {
    paint();
    // The drawer and bag re-render from section HTML, and the PDP rewrites its dispatch line.
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    // A tab left open past the cut-off or midnight catches up when the shopper comes back to it.
    document.addEventListener('visibilitychange', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
